<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="PcWeb" toName="编辑" cneterName="其他信息" goPathName="PC网站"></Breadcrumb>
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="currentFormLayout2.labelCol"
        :wrapper-col="currentFormLayout2.wrapperCol">
        <a-form-model-item label="内容标题" prop="title">
          <a-input
            disabled
            v-model="ruleForm.title"
            placeholder="请输入"
            :maxLength="60"
            style="max-width:500px;"/>
        </a-form-model-item>
        <a-form-model-item label="内容正文" prop="content">
          <a-textarea
            v-model="ruleForm.content"
            placeholder="请输入"
            :rows="8"
            :maxLength="20000"
            style="max-width:500px;"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
          <a-button style="margin-left: 3%;" @click="goReset">重置</a-button>
          <a-button style="margin-left: 3%;" @click="goBack">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'EditOtherInfo',
  components: {
    Breadcrumb
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      ruleForm: {
        title: '',
        content: ''
      },
      rules: {
        title: [{ required: true, message: '请输入', trigger: 'blur' }],
        content: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      submitLoading: false,
      id: ''
    }
  },
  activated() {
    this.goReset()
    this.id = this.$route.query.id
    this.$refs.ruleForm.resetFields()
    if (this.id) {
      this.getDetails()
    }
  },
  methods: {
    getDetails() {
      let url = 'pc/v2/other-data/query/' + this.id
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          this.ruleForm.title = res.title
          this.ruleForm.content = res.content
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    goReset() {
      this.ruleForm.content = ''
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleOk()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    handleOk() {
      let parms = {
        title: this.ruleForm.title,
        content: this.ruleForm.content
      }
      if (this.id) {
        parms.id = this.id
      }
      this.submitLoading = true
      this.getHttpServices().getUserService().post('pc/v2/other-data/save', parms)
        .then(res => {
          this.$message.success('保存成功')
          this.submitLoading = false
          this.goBack()
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.submitLoading = false
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.image-hint {
  margin-left: 20px;
}
</style>